import { z } from 'zod';

/**
 * One operation as `GET /release-components/:id/operations/:opId` returns it.
 * `stalled` and `retryable` are computed by the server (design B3), so the web
 * never reimplements the stall threshold or the retry window.
 */
export const ReleaseOperation = z.object({
    operationId: z.string(),
    releaseId: z.string(),
    scope: z.enum(['all', 'clients']),
    enabled: z.boolean(),
    state: z.enum(['running', 'complete', 'partial']),
    stalled: z.boolean(),
    retryable: z.boolean(),
    attempt: z.number().int().positive(),
    counters: z.object({
        total: z.number().int().nonnegative(),
        applied: z.number().int().nonnegative(),
        skipped: z.number().int().nonnegative(),
        failed: z.number().int().nonnegative(),
        pending: z.number().int(),
    }),
    createdAt: z.string(),
    updatedAt: z.string(),
    finishedAt: z.string().optional(),
    closedReason: z.enum(['abandoned', 'targets-incomplete']).optional(),
});
export type ReleaseOperation = z.infer<typeof ReleaseOperation>;

/** The 202 answer of the start route. */
export const StartedOperation = z.object({ operationId: z.string() });
export type StartedOperation = z.infer<typeof StartedOperation>;

/** One chunk of the turn-off preview (≤ 100 clients); the web sums the chunks. */
export const ClientsPreview = z.object({
    overwriteCount: z.number().int().nonnegative(),
    entitlementHeld: z.number().int().nonnegative(),
    incomplete: z.boolean(),
});
export type ClientsPreview = z.infer<typeof ClientsPreview>;
